import { createRouter, createWebHashHistory } from 'vue-router'
import StartView from '../views/StartView.vue'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'start',
      component: StartView,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/home',
      name: 'home',
      component: HomeView,
    }
  ],
})

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    const hasEnteredLobby = localStorage.getItem('hasEnteredLobby')
    if (hasEnteredLobby === 'true') {
      next('/home')
      return
    }
  }
  next()
})

export default router
